import React from 'react';
import { Search } from 'lucide-react';
import './EmptyState.css';

function EmptyState({
  icon: Icon,
  title = 'No records found',
  description,
  actionLabel,
  onAction,
  actionIcon: ActionIcon,
}) {
  return (
    <div className="empty-state-container">
      {Icon && (
        <div className="empty-state-icon-wrapper">
          <Icon size={48} className="empty-state-icon-lg" />
        </div>
      )}
      <h3 className="empty-state-heading">{title}</h3>
      {description && (
        <p className="empty-state-desc">{description}</p>
      )}
      {actionLabel && onAction && (
        <button className="btn btn-primary empty-state-action" onClick={onAction}>
          {ActionIcon && <ActionIcon size={18} />}
          {actionLabel}
        </button>
      )}
    </div>
  );
}

/**
 * Variant for when a search/filter yields no results (not truly empty).
 * Shows a "No results found" message with a "Clear Filters" CTA.
 */
function EmptyStateFiltered({ onClearFilters }) {
  return (
    <EmptyState
      icon={Search}
      title="No results found"
      description="Try adjusting your search or filters to find what you're looking for."
      actionLabel="Clear Filters"
      onAction={onClearFilters}
    />
  );
}

export default EmptyState;
export { EmptyStateFiltered };
